$(document).ready(function(){
  //   accordion
  $(function () {
      $(".acc__title").click(function (j) {
        var dropDown = $(this).closest(".acc__card").find(".acc__panel");
        $(this).closest(".accordion-part").find(".acc__panel").not(dropDown).slideUp();

        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
        } else {
          $(this).closest(".accordion-part").find(".acc__title.active").removeClass("active");
          $(this).addClass("active");
        }

        dropDown.stop(false, true).slideToggle();
        j.preventDefault();
      });
    });
  
  // Product template -> example sliders
  $(".product-template__container .example-images").slick({
    lazyLoad: 'ondemand',
    dots: false,
    autoplay: false,
    speed: 1000,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

});